import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { api } from '../../../services/apiClient';

const Pagamentos = () => {
  return <h1>Pagamentos</h1>;
};

export default Pagamentos;
